import type { getLogger } from '../commons/logger';

export function isOldProtocol(err: Error) {
    return (
        err.message?.match(/Command not found/) ||
        err.message === 'HTTP method not allowed' ||
        err.message?.toLowerCase() === 'unknown error' ||
        err.message?.match(/Unknown timeout type/) ||
        err.name === 'unknown command' ||
        err.message?.match(/did not match a known command/) ||
        err.message?.match(/Server returned HTTP response code: 405 for URL/) ||
        // @ts-expect-error TODO: seleniumStack doesn't exist anymore
        err.seleniumStack?.message === 'The arguments passed to a command are either invalid or malformed.' ||
        err.message?.match(/Invalid timeout type specified: ms/) ||
        err.message?.match(/\.\w* is not a function/)
    );
}

export function encodeForSafari(url: string | undefined | null, isSafari?: boolean, logger?: ReturnType<typeof getLogger>) {
    if (!isSafari || !url) {
        return url;
    }

    // don't touch the URL if it has %. Technically incorrect (% alone breaks Safari),
    // but otherwise we can break other people's URLs. Replace spaces because it's safe.
    if (url.includes('%')) {
        return url.replace(/ /g, '%20');
    }

    try {
        const isAlreadyEncoded = decodeURI(url) !== url;
        if (isAlreadyEncoded) {
            return url;
        }
        return encodeURI(url);
    } catch (err) {
        if (logger) {
            logger.warn('tried to encode url but failed', { err, url });
        }
        return url;
    }
}
